module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), (_vm.showNavBar) ? _c('nav-bar', {
    attrs: {
      "show": true
    }
  }) : _vm._e(), _vm._v(" "), _c('app-main')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a63ae31c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 347
// module chunks = 1